import { createFileRoute } from "@tanstack/react-router";
import { Schema } from "effect";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";

const sitesSearchSchema = parseableSearchSchema(
  Schema.Struct({
    status: optionalLiteralParam("all", "pending_review", "building", "online", "other"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/sites/")({
  validateSearch: sitesSearchSchema
});
